export default [
    { title: 'Temperatura del agua', id: 'item1', src: 't_agua.png', src_hover: 't_agua_h.png', route: '/GroundWaterInformationPdf' },
    { title: 'Carga hidrostática', id: 'item2', src: 'c_hidrostatica.png', src_hover: 'c_hidrostatica_h.png', route: '/GroundWaterInformationPdf'}
  ]